import { render, staticRenderFns } from "./BbcsTicket.vue?vue&type=template&id=702d80de&"
import script from "./BbcsTicket.vue?vue&type=script&lang=js&"
export * from "./BbcsTicket.vue?vue&type=script&lang=js&"
import style0 from "./BbcsTicket.vue?vue&type=style&index=0&id=702d80de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BbcsTicket.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports